import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import type { AvailabilitySlotCalendarEvent } from '../../../types';
import { EventCardWrapper } from '../../column-events/event-card-wrapper';

interface Props {
  event: AvailabilitySlotCalendarEvent;
}
export const AvailabilitySlotEvent = ({ event }: Props) => {
  return (
    <EventCardWrapper eventType={'availabilitySlot'} containerStyle={containerStyle}>
      {event.eventType}
    </EventCardWrapper>
  );
};

const containerStyle = css({
  padding: theme.spacing(0.5),
  borderRadius: theme.borderRadius.small,
  background: theme.colors.primary20,
  border: `1px solid ${theme.colors.primary50}`,
});
